<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          <span>Edit Module</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.name"
                outlined
                label="Module Name *"
                prepend-inner-icon="mdi-cube-outline"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            color="primary"
            rounded
            dark
            @click="save"
          >
            Update Module
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "@/axios";
export default {
  name: "ModuleEditPage",
  data() {
    return {
      form: {
        name: "",
        is_active: true,
      },
      isLoading: false,
    };
  },
  computed: {
    errors() {
      return this.$store.getters['errors/getErrors'];
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.moduleId;
      await axios
        .get(`/modules/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.isLoading = false;
        });
    },
    async save() {
      try {
        this.isLoading = true;
        
        await axios
          .patch(`/modules/${this.$route.params.moduleId}`, this.form)
          .then(() => {
            this.$router.push("/modules");
          })
          .catch((error) => {
            console.error("Error updating module:", error);
          });
      } catch (e) {
        console.error("Error:", e);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>